export default __webpack_public_path__ + "static/media/list-color-incorrect.71d76254.png";